// React hook that is used to mark the block wrapper element.
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { createBlock } from '@wordpress/blocks';
// WordPress data store
import { dispatch, select } from '@wordpress/data';
const { useEffect } = wp.element;

// editor style
import './editor.scss';

/**
 * Internal dependencies
 */
import Inspector from './inspector';

export default function Edit( props ) {
	const { id, uniqueID, gapDBetweenBlocks, deskCols, tabCols, mobCols } =
		props.attributes;

	useEffect( () => {
		if ( ! uniqueID ) {
			props.setAttributes( {
				uniqueID: props.clientId.slice( 0, 8 ),
				id: props.clientId.slice( 0, 8 ),
			} );
		}
	}, [] );

	// Block Props
	const blockProps = useBlockProps( {
		className: `${
			id || ''
		} wtrbmr-${ uniqueID } wtrbs__dcols_${ deskCols } wtrbs__tcols_${ tabCols } wtrbs__mcols_${ mobCols }`,
		style: { gap: `${ gapDBetweenBlocks }px` },
	} );

	const insertBoxSloganBlock = () => {
		const innerCount = select( 'core/editor' ).getBlocksByClientId(
			props.clientId
		)[ 0 ].innerBlocks.length;

		// if innercount is odd, add an "EVEN item"
		if ( innerCount % 2 === 1 ) {
			const block = createBlock( 'wtrb/boxsloganmember', {
				config: 'imagebottom',
			} );
			dispatch( 'core/block-editor' ).insertBlock(
				block,
				innerCount,
				props.clientId
			);
		}
		// if innerCount is even, add an "ODD item"
		if ( innerCount % 2 === 0 ) {
			const block = createBlock( 'wtrb/boxsloganmember', {
				config: 'imagetop',
			} );
			dispatch( 'core/block-editor' ).insertBlock(
				block,
				innerCount,
				props.clientId
			);
		}
	};

	/**
	 * Inner Block Props
	 */
	const innerBlocksProps = useInnerBlocksProps( blockProps, {
		allowedBlocks: [ 'wtrb/boxsloganmember' ],
		template: [
			[ 'wtrb/boxsloganmember', { config: 'imagetop' } ],
			[ 'wtrb/boxsloganmember', { config: 'imagebottom' } ],
			[ 'wtrb/boxsloganmember', { config: 'imagetop' } ],
		],
		renderAppender: () => (
			<button
				className="components-button block-editor-button-block-appender"
				type="button"
				onClick={ insertBoxSloganBlock }
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					width="24"
					height="24"
					aria-hidden="true"
					focusable="false"
				>
					<path d="M18 11.2h-5.2V6h-1.6v5.2H6v1.6h5.2V18h1.6v-5.2H18z"></path>
				</svg>
			</button>
		),
	} );

	return (
		<>
			<Inspector
				attributes={ props.attributes }
				setAttributes={ props.setAttributes }
			/>

			<div { ...innerBlocksProps } />
		</>
	);
}
